import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';

function ModalLoading(props) {
    return (
        <Modal
        size="sm"
            show={props.ShowModal}
            onHide={() => props.SetShowModalHide()}
            aria-labelledby="contained-modal-title-vcenter"
            
        >
            <Modal.Body
            className="text-center bg-white"
            >
              <img  src={require('../../../assets/images/new_loading.gif')}  style={{
                  height:100,
                 
                  
              }}/>
            </Modal.Body>
        </Modal>
    )
}
export default ModalLoading;